import { axiosAuth } from "services/generic/AxiosInterceptor/AxiosInterceptor"
import { generateFormData } from "services/generic/HttpUtils"

import { UziCertificateStatusResponse } from "@shared/zod/schemas/responses/uziCertificate"

export const getStatus = async (practiceId: string): Promise<UziCertificateStatusResponse> => {
  return axiosAuth({
    url: `/uzi-certificate/settings/${practiceId}`,
    method: "get",
  }).then((resp) => {
    return resp.data
  })
}

export const upload = async (
  practiceId: string,
  publicCert: File,
  privateKey: File
): Promise<UziCertificateStatusResponse> => {
  return await axiosAuth({
    url: `/uzi-certificate/settings/${practiceId}`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: generateFormData({}, [publicCert, privateKey], ["publicCert", "privateKey"]),
  }).then((resp) => {
    return resp.data
  })
}
